import { render } from "./textInputModal.vue?vue&type=template&id=2aaa2d49&ts=true"
import script from "./textInputModal.vue?vue&type=script&lang=ts"
export * from "./textInputModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__